import Utils from '../../../../common/js/Utils';

export default class QuizCertificate {

    static initializeEvents() {
        const quizCertificateForm = document.querySelector('.quiz[data-content-id] .quiz-result .quiz-certificate-form:not([aria-hidden])');
        this.attachEventToFormSubmission(quizCertificateForm);

        Array
            .from(document.querySelectorAll('.quiz'))
            .forEach(element => {
                element.addEventListener('quizEnd', event => {
                    const quizEnabledPlugins = event.detail.enabledPlugins;
                    const quizContentIdentifier = event.detail.contentId;
                    const quizIdentificationIdentifier = event.detail.identificationIdentifier;

                    if (quizEnabledPlugins.includes('QuizCertificate') && quizContentIdentifier) {
                        const quizCertificateForm = document.querySelector('.quiz[data-content-id="' + quizContentIdentifier + '"] .quiz-result .quiz-certificate-form');

                        this.sendQuizEndRequest(quizCertificateForm, quizContentIdentifier, quizIdentificationIdentifier);
                        this.attachEventToFormSubmission(quizCertificateForm);
                    }
                });
            });
    }

    static attachEventToFormSubmission(quizCertificateForm) {
        if (quizCertificateForm) {
            quizCertificateForm.querySelector('form').addEventListener('submit', event => {
                event.preventDefault();

                this.showFormMessage(quizCertificateForm, 'loading');

                fetch(event.currentTarget.action, {method: 'post', body: new FormData(event.currentTarget)})
                    .then(response => {
                        if (response.status >= 200 && response.status < 300) {
                            this.showFormMessage(quizCertificateForm, 'success', MAIL_SUCCESS_MESSAGE);
                        } else {
                            this.showFormMessage(quizCertificateForm, 'error', MAIL_ERROR_MESSAGE);
                        }
                    })
                    .catch(() => this.showFormMessage(quizCertificateForm, 'error', MAIL_ERROR_MESSAGE));
            });

            quizCertificateForm.classList.remove('hidden');
            quizCertificateForm.removeAttribute('aria-hidden');
        }
    }

    static sendQuizEndRequest(quizCertificateForm, quizContentIdentifier, quizIdentificationIdentifier) {
        Utils
            .request('/quiz/save_ine/' + quizContentIdentifier + '/' + quizIdentificationIdentifier, 'POST')
            .catch(() => this.showFormMessage(quizCertificateForm, 'error', ATTESTATION_ERROR_MESSAGE));
    }

    static showFormMessage(quizCertificateForm, mode, message) {
        const formSubmitButton = quizCertificateForm.querySelector('[type="submit"]');

        if (mode === 'success' || mode === 'loading') {
            formSubmitButton.setAttribute('disabled', '');

            if (mode === 'loading') {
                return;
            }
        }

        if (mode === 'error') {
            formSubmitButton.removeAttribute('disabled');
        }

        const currentFormMessage = quizCertificateForm.querySelector('.text-success, .text-error');
        if (currentFormMessage) {
            currentFormMessage.parentNode.removeChild(currentFormMessage);
        }

        const newFormMessage = document.createElement('p');
        if (mode === 'success') {
            newFormMessage.classList.add('text-success', 'mt-2w');
            newFormMessage.innerHTML = '<strong>Votre demande a été reçue : vous recevrez votre attestation d\'ici quelques minutes.</strong>';
        } else {
            newFormMessage.classList.add('text-error', 'mt-2w');
        }

        newFormMessage.innerHTML = '<strong>' + message + '</strong>';

        if (message === ATTESTATION_ERROR_MESSAGE) {
            Array
                .from(quizCertificateForm.children)
                .forEach(child => quizCertificateForm.removeChild(child));
        }

        quizCertificateForm.appendChild(newFormMessage);
    }

}